import { useCallback, useState, useEffect } from "react";
import Main from "../../components/layouts/Main";
import PageTitle from "../../components/utils/PageTitle";
import Breadcrumb from "../../components/utils/Breadcrumb";
import { catchError } from "../../services/DaoService";
import {
  Button,
  Spin,
} from "antd";
import {
  DragOutlined,
  PlusCircleFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import { StatutService } from "../../services/StatutService";
import StatutCreateForm from "../../components/statut/StatutCreateForm";
import StatutList from "../../components/statut/StatutList";
// import PropTypes from "prop-types";


export default function StatutListPage() {
  const [loading, setLoading] = useState(true);
  const [newModalVisible, setNewModalVisible] = useState(false);
  const [statuts, setStatuts] = useState([]);
  const [reorder, setReorder] = useState(false);

  const init = useCallback(() => {
    setLoading(true);
    StatutService.getInstance()
      .search({})
      .then((response) => {
        setStatuts(response.data.data);
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    init();
  }, [reorder, init]);

  const handleCreation = () => {
    init();
  };
  return (
    <Main>
      <Breadcrumb
        parentLink="/settings"
        canSee={true}
        parentLinkTitle="Paramètrage"
        title="Statuts"
      />
      <PageTitle
        title="Liste des statuts"
        subTitle="Gestion des statuts"
        icon={<PlusCircleFilled />}
      >
        <Button
            type="primary"
            icon={<PlusCircleFilled />}
            onClick={() => setNewModalVisible(true)}
          >
            Ajouter un statut
          </Button>
        {!reorder && (
          <Button
            type="dashed"
            icon={<DragOutlined />}
            onClick={() => setReorder(!reorder)}
          >
            Réordonner
          </Button>
        )}
        <Button type="default" icon={<ReloadOutlined />} onClick={init}>
          Rafraîchir
        </Button>
      </PageTitle>
      <Spin spinning={loading}>
        <StatutList statuts={statuts} setStatuts={setStatuts} reorder={reorder} setReorder={setReorder} />
      </Spin>

      <StatutCreateForm
        visible={newModalVisible}
        onCreate={handleCreation}
        onCancel={() => setNewModalVisible(false)}
      />
    </Main>
  );
}


StatutListPage.propTypes = {
  // renseigner les props du composant ici
};
